import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowUpCircle"><Path d="M21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 16.5V8" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 11L12 7.5L15.5 11" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowUpCircle;
